import loadable from '@loadable/component';

export const AuthSignupPageLoadable = loadable(
  () => import('./AuthSignupPage'),
  { resolveComponent: (module) => module.AuthSignupPage },
);
